"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
var _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideWorkflowConfirm = exports.showWorkflowConfirm = exports.setTicketForecastValue = exports.setTicketState = exports.ticketSlice = exports.updateTicketField = exports.duplicateTicket = exports.updateTicketProperty = exports.deleteTicketTag = exports.saveTicketTags = exports.toggleWatchTask = exports.toggleEscalateTask = exports.cascadeUserAssignments = exports.TICKET_WORKFLOW_OPTIONS = exports.TICKET_WORKFLOWS = exports.TICKET_TYPE_OPTIONS = exports.TICKET_TYPES = exports.TicketAllowedUpdateProperties = exports.TicketDisplayOption = void 0;
const pulse_components_1 = require("@pcs/pulse-components");
const toolkit_1 = require("@reduxjs/toolkit");
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const qs_1 = __importDefault(require("qs"));
const helpers_1 = require("../helpers");
const assetDetailSlice_1 = require("./assetDetailSlice");
var TicketDisplayOption;
(function (TicketDisplayOption) {
    TicketDisplayOption["general"] = "display.general";
    TicketDisplayOption["vendor"] = "display.vendor";
    TicketDisplayOption["client"] = "display.client";
    TicketDisplayOption["calendar"] = "display.calendar";
})(TicketDisplayOption = exports.TicketDisplayOption || (exports.TicketDisplayOption = {}));
var TicketAllowedUpdateProperties;
(function (TicketAllowedUpdateProperties) {
    TicketAllowedUpdateProperties["progress"] = "progress";
    TicketAllowedUpdateProperties["forecast"] = "forecastEffortHours";
    TicketAllowedUpdateProperties["maxRoundsAllowed"] = "maxRoundsAllowed";
    TicketAllowedUpdateProperties["cascadeUserAssignments"] = "assignUsersToNextTaskOnCompletion";
    TicketAllowedUpdateProperties["type"] = "type.id";
})(TicketAllowedUpdateProperties = exports.TicketAllowedUpdateProperties || (exports.TicketAllowedUpdateProperties = {}));
exports.TICKET_TYPES = (_e = (_d = (_c = (_b = window.pulse) === null || _b === void 0 ? void 0 : _b.request) === null || _c === void 0 ? void 0 : _c.formOptions) === null || _d === void 0 ? void 0 : _d.types) !== null && _e !== void 0 ? _e : [];
/** Convert the TICKET_TYPES to a signature readable by PulseSelectBase */
exports.TICKET_TYPE_OPTIONS = exports.TICKET_TYPES.length > 0
    ? exports.TICKET_TYPES.map((type) => ({
        label: type.title,
        value: type.id,
    }))
    : [];
exports.TICKET_WORKFLOWS = (_j = (_h = (_g = (_f = window.pulse) === null || _f === void 0 ? void 0 : _f.request) === null || _g === void 0 ? void 0 : _g.formOptions) === null || _h === void 0 ? void 0 : _h.workflows) !== null && _j !== void 0 ? _j : [];
/** Convert the TICKET_TYPES to a signature readable by PulseSelectBase */
exports.TICKET_WORKFLOW_OPTIONS = exports.TICKET_WORKFLOWS.length > 0
    ? exports.TICKET_WORKFLOWS.map((workflow) => ({
        label: workflow.title,
        value: workflow.id,
    }))
    : [];
const initialState = {
    data: null,
    isTogglingEscalateTask: false,
    isTogglingWatchTask: false,
    isTogglingDisplay: {
        [TicketDisplayOption.general]: false,
        [TicketDisplayOption.vendor]: false,
        [TicketDisplayOption.client]: false,
        [TicketDisplayOption.calendar]: false,
    },
    isTogglingCascadeUserAssignments: false,
    isUpdatingTicketProperty: [],
    isUpdatingTicketField: [],
    isWorkflowConfirmVisible: false,
};
const TICKET_ENDPOINT = window.pulse.config.urls.api;
exports.cascadeUserAssignments = (0, toolkit_1.createAsyncThunk)('ticket/cascadeUserAssignments', async (undefined, { getState }) => {
    const { ticket: { data }, } = getState();
    if (!data) {
        throw new Error('Failed to update ticket priority. No ticket id found.');
    }
    const { ticketid: ticketId, assign_to_next_task } = data;
    const postData = {
        action: 'tasks',
        type: 'update-property',
        task: ticketId,
        property: TicketAllowedUpdateProperties.cascadeUserAssignments,
        value: assign_to_next_task !== 'y',
    };
    return pulse_components_1.v2Endpoint
        .post(TICKET_ENDPOINT, qs_1.default.stringify(postData), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
        .then((res) => {
        if (!res.data.success) {
            throw new Error('Failed to update ticket priority');
        }
    });
});
exports.toggleEscalateTask = (0, toolkit_1.createAsyncThunk)('ticket/toggleEscalated', async (ticket) => {
    const ticketId = ticket === null || ticket === void 0 ? void 0 : ticket.ticketid;
    if (!ticketId) {
        throw new Error('Failed to update ticket priority. No ticket id found.');
    }
    const data = (0, helpers_1.getPriorityDataSubmission)((ticket === null || ticket === void 0 ? void 0 : ticket.priority) || helpers_1.PRIORITY.deescalated);
    const postData = {
        action: 'tasks',
        type: 'update-property',
        task: ticketId,
        property: 'priority.id',
        value: data.id,
        data,
    };
    return pulse_components_1.v2Endpoint
        .post(TICKET_ENDPOINT, qs_1.default.stringify(postData), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
        .then((res) => {
        if (!res.data.success) {
            throw new Error('Failed to update ticket priority');
        }
    });
});
exports.toggleWatchTask = (0, toolkit_1.createAsyncThunk)('ticket/toggleWatch', async (ticket) => {
    const ticketId = ticket === null || ticket === void 0 ? void 0 : ticket.ticketid;
    if (!ticketId) {
        throw new Error('Failed to update ticket watch. No ticket id found.');
    }
    const postData = {
        action: 'tasks',
        type: 'toggle-watch-task',
        task: ticket.ticketid,
        property: 'watching',
        value: !ticket.is_watching,
    };
    return pulse_components_1.v2Endpoint
        .post(TICKET_ENDPOINT, qs_1.default.stringify(postData), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
        .then((res) => {
        if (!res.data.success) {
            throw new Error('Failed to update ticket watch');
        }
    });
});
exports.saveTicketTags = (0, toolkit_1.createAsyncThunk)('ticket/saveTag', async ({ ticketId, tags }, { dispatch }) => {
    dispatch((0, assetDetailSlice_1.setIsLoadingAssetDetail)(true));
    const formattedTags = tags.map((options) => options.label.toString());
    const params = {
        action: 'tasks',
        type: 'add-ticket-tags',
        ticketId,
        tags: formattedTags,
    };
    return pulse_components_1.v2Endpoint.get(TICKET_ENDPOINT, { params }).then((res) => {
        if (res.data.success) {
            dispatch((0, assetDetailSlice_1.setIsLoadingAssetDetail)(false));
            return tags.map((option) => ({
                type: 'tags',
                id: option.value,
                tag_id: option.value,
                name: option.label,
            }));
        }
        throw new Error('Failed to update ticket tags.');
    });
});
exports.deleteTicketTag = (0, toolkit_1.createAsyncThunk)('ticket/deleteTag', async ({ ticketId, tags }, { dispatch }) => {
    if (!tags) {
        return;
    }
    dispatch((0, exports.saveTicketTags)({ ticketId, tags }));
});
exports.updateTicketProperty = (0, toolkit_1.createAsyncThunk)('ticket/updateTicketProperty', async ({ property, value }, { getState }) => {
    var _a;
    const { ticket } = getState();
    if (!ticket.data) {
        throw new Error('Missing data property on ticket');
    }
    const params = {
        action: 'tasks',
        type: 'update-property',
        task: (_a = ticket.data) === null || _a === void 0 ? void 0 : _a.ticketid,
        property,
        value,
    };
    pulse_components_1.v2Endpoint
        .post(TICKET_ENDPOINT, qs_1.default.stringify(params), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
        .then((res) => {
        if (!res.data.success) {
            throw new Error('Failed to update ticket');
        }
    });
});
exports.duplicateTicket = (0, toolkit_1.createAsyncThunk)('ticket/duplicate', async (ticketId) => {
    const params = {
        action: 'tasks',
        type: 'duplicate',
        taskId: ticketId,
    };
    return pulse_components_1.v2Endpoint.get(TICKET_ENDPOINT, { params }).then((res) => {
        if (res.data.success) {
            return true;
        }
        throw new Error('Failed to duplicate ticket');
    });
});
exports.updateTicketField = (0, toolkit_1.createAsyncThunk)('ticket/updateField', async ({ field, value }, { getState }) => {
    var _a;
    const { assetDetail: { asset }, ticket, } = getState();
    const job = asset === null || asset === void 0 ? void 0 : asset.job;
    const url = `${window.pulse.config.urls.app}ajax/task/${(_a = ticket.data) === null || _a === void 0 ? void 0 : _a.ticketid}/task-fields`;
    const data = {
        jobid: job === null || job === void 0 ? void 0 : job.id,
        fieldId: field.id,
        value,
    };
    return pulse_components_1.v2Endpoint
        .post(url, qs_1.default.stringify(data), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
        .then((res) => {
        return res.data;
    });
});
exports.ticketSlice = (0, toolkit_1.createSlice)({
    name: 'ticketSlice',
    initialState,
    reducers: {
        setTicketState: (state, action) => {
            state.data = action.payload;
        },
        setTicketForecastValue: (state, action) => {
            var _a;
            if ((_a = state.data) === null || _a === void 0 ? void 0 : _a.forecast_effort) {
                state.data.forecast_effort = action.payload;
            }
        },
        showWorkflowConfirm: (state) => {
            state.isWorkflowConfirmVisible = true;
        },
        hideWorkflowConfirm: (state) => {
            state.isWorkflowConfirmVisible = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(exports.saveTicketTags.fulfilled, (state, action) => {
            if (state.data) {
                state.data.tags = action.payload;
                utilities_1.default.notification.success('Ticket tags updated');
            }
        });
        builder.addCase(exports.saveTicketTags.rejected, () => {
            utilities_1.default.notification.warning('Failed to save ticket tags.');
        });
        builder.addCase(exports.toggleEscalateTask.pending, (state) => {
            state.isTogglingEscalateTask = true;
        });
        builder.addCase(exports.toggleEscalateTask.fulfilled, (state) => {
            state.isTogglingEscalateTask = false;
            if (state.data) {
                state.data.priority =
                    state.data.priority === helpers_1.PRIORITY.escalated
                        ? helpers_1.PRIORITY.deescalated
                        : helpers_1.PRIORITY.escalated;
                utilities_1.default.notification.success('The ticket priority have been updated successfully');
            }
        });
        builder.addCase(exports.toggleEscalateTask.rejected, (state) => {
            state.isTogglingEscalateTask = false;
            utilities_1.default.notification.danger(`Failed to update ticket priority`);
        });
        builder.addCase(exports.toggleWatchTask.pending, (state) => {
            state.isTogglingWatchTask = true;
        });
        builder.addCase(exports.toggleWatchTask.fulfilled, (state) => {
            state.isTogglingWatchTask = false;
            if (state.data) {
                state.data.is_watching = !state.data.is_watching;
                utilities_1.default.notification.success('You are now watching this ticket');
            }
        });
        builder.addCase(exports.toggleWatchTask.rejected, (state) => {
            state.isTogglingWatchTask = false;
            utilities_1.default.notification.danger(`Failed to set you as a watcher`);
        });
        builder.addCase(exports.updateTicketProperty.pending, (state, action) => {
            state.isUpdatingTicketProperty.push(action.meta.arg.property);
        });
        builder.addCase(exports.updateTicketProperty.fulfilled, (state, action) => {
            state.isUpdatingTicketProperty = state.isUpdatingTicketProperty.filter((property) => property !== action.meta.arg.property);
            let propertyMessage = 'Ticket';
            if (state.data) {
                switch (action.meta.arg.property) {
                    case TicketDisplayOption.general:
                        state.data.display_to_general = action.meta.arg.value ? 'y' : 'n';
                        propertyMessage = 'Display to general';
                        break;
                    case TicketDisplayOption.calendar:
                        state.data.visible_on_calendar = action.meta.arg.value ? 'y' : 'n';
                        propertyMessage = 'Show on calendar';
                        break;
                    case TicketDisplayOption.client:
                        state.data.display_to_client = action.meta.arg.value ? 'y' : 'n';
                        propertyMessage = 'Display to client';
                        break;
                    case TicketDisplayOption.vendor:
                        state.data.display_to_vendor = action.meta.arg.value ? 'y' : 'n';
                        propertyMessage = 'Display to vendor';
                        break;
                    case TicketAllowedUpdateProperties.forecast:
                        state.data.forecast_effort = action.meta.arg.value;
                        propertyMessage = 'Forecast';
                        break;
                    case TicketAllowedUpdateProperties.progress:
                        state.data.progress = action.meta.arg.value;
                        propertyMessage = 'Progress';
                        break;
                    case TicketAllowedUpdateProperties.maxRoundsAllowed:
                        state.data.max_rounds_allowed = action.meta.arg.value;
                        propertyMessage = 'Number of planned rounds';
                        break;
                    case TicketAllowedUpdateProperties.cascadeUserAssignments:
                        state.data.assign_to_next_task = action.meta.arg.value ? 'y' : 'n';
                        propertyMessage = 'Cascade user assignments';
                        break;
                    case TicketAllowedUpdateProperties.type:
                        state.data.type = exports.TICKET_TYPES.filter((type) => type.id === action.meta.arg.value)
                            .map(({ id, title, hex_color }) => ({
                            type: 'ticket-types',
                            ticket_type_id: parseInt(id, 10),
                            id,
                            name: title,
                            color: hex_color,
                        }))
                            .pop();
                        propertyMessage = 'Type';
                        break;
                    default:
                }
                utilities_1.default.dismissNotifications();
                utilities_1.default.notification.success(`${propertyMessage} updated`);
            }
        });
        builder.addCase(exports.updateTicketProperty.rejected, (state, action) => {
            state.isUpdatingTicketProperty = state.isUpdatingTicketProperty.filter((property) => property !== action.meta.arg.property);
            utilities_1.default.dismissNotifications();
            utilities_1.default.notification.danger('Failed to update ticket');
        });
        builder.addCase(exports.duplicateTicket.fulfilled, () => {
            utilities_1.default.dismissNotifications();
            utilities_1.default.notification.success('Task has been duplicated');
        });
        builder.addCase(exports.duplicateTicket.rejected, () => {
            utilities_1.default.dismissNotifications();
            utilities_1.default.notification.success('Unable to duplicate task');
        });
        builder.addCase(exports.updateTicketField.pending, (state, action) => {
            state.isUpdatingTicketField.push(action.meta.arg.field.id);
        });
        builder.addCase(exports.updateTicketField.fulfilled, (state, action) => {
            var _a;
            if ((_a = state.data) === null || _a === void 0 ? void 0 : _a.fields) {
                state.data.fields = action.payload;
                state.isUpdatingTicketField = state.isUpdatingTicketField.filter((field) => field !== action.payload[0].id);
                utilities_1.default.dismissNotifications();
                utilities_1.default.notification.success(`${action.payload[0].caption} was updated`);
            }
        });
        builder.addCase(exports.updateTicketField.rejected, (state, action) => {
            utilities_1.default.dismissNotifications();
            utilities_1.default.notification.danger(`Failed to update ${action.meta.arg.field.caption}`);
        });
    },
});
_a = exports.ticketSlice.actions, exports.setTicketState = _a.setTicketState, exports.setTicketForecastValue = _a.setTicketForecastValue, exports.showWorkflowConfirm = _a.showWorkflowConfirm, exports.hideWorkflowConfirm = _a.hideWorkflowConfirm;
exports.default = exports.ticketSlice.reducer;
